<template>
  <v-data-table
    v-bind="$attrs"
    :class="{ [`spaced-table ${gap}`]: gapType.includes(gap) }"
    hide-default-footer
    v-on="$listeners"
  >
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
    >
      <slot v-bind="scope" :name="slot" />
    </template>
  </v-data-table>
</template>

<script>
const gapType = ['low', 'mid', 'high']

export default {
  name: 'BaseDataTable',

  props: {
    gap: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    gapType,
  }),
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/settings/_variables';
// Override default data table styles
.spaced-table {
  // applying these styles only when tables are spaced
  .v-data-table__wrapper table thead tr th {
    height: 20px;
  }

  &.low .v-data-table__wrapper table {
    border-spacing: 0 0.25rem;
  }

  &.mid .v-data-table__wrapper table {
    border-spacing: 0 0.5rem;
  }

  &.high .v-data-table__wrapper table {
    border-spacing: 0 1rem;
  }
}
.theme--light {
  .v-data-table {
    background-color: transparent;
    .v-data-table__wrapper {
      table {
        tbody {
          tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
            background-color: #fff;
          }
        }
      }
    }
    thead {
      background-color: var(--v-secondary-base);

      tr {
        background-color: transparent;
      }
    }

    th {
      border-bottom: none !important;
      color: var(--v-lightCarbon-base) !important;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }

    tr {
      background-color: #fff;
    }

    tr {
      $row-padding: 30px;
      // $breakpoint-mobile: 600px;
      // @media only screen and (max-width: $breakpoint-mobile) {
      //   $row-padding: 16px;
      // }

      & > td:first-child {
        padding-left: $row-padding !important;
      }

      /* & > td:last-child {
      padding-right: 0 !important;
    } */

      & > th:first-child {
        padding-left: $row-padding !important;
      }

      & > th:last-child {
        padding-right: 0 !important;
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .theme--light .v-data-table {
    tr {
      & > td:first-child {
        padding-left: 16px !important;
      }
      & > th:first-child {
        padding-left: 0px !important;
      }
    }

    & > .v-data-table__wrapper table tbody tr td {
      height: 56px !important;
    }
  }

  .v-data-table__mobile-row {
    padding-top: 16px !important;
    align-items: flex-start !important;
  }

  .v-data-table__wrapper {
    overflow: hidden !important;
  }

  .header-text {
    font-size: 20px !important;
  }
}
</style>
